import { Link } from "react-router-dom";
import { Space, Button, Checkbox, Form, Input, Typography } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { ConnectedProps } from "react-redux";
import { useEffect } from "react";

import logo from "../../../images/logo.svg";
import { NavigationPath } from "../../../utils";
import { type LoginFieldType } from "../../../models";
import connector from "./Container";

const Login = ({ actions }: ConnectedProps<typeof connector>) => {
  useEffect(() => {
    localStorage.removeItem("userToken");
  }, []);

  const onFinish = (values: LoginFieldType) => {
    actions.loginUser(values);
  };

  return (
    <div className="flex flex-col h-screen items-center justify-center bg-secondary">
      <div className="pb-10 text-offer-blue pt-20 rounded-md w-5/6 sm:w-[450px] m-auto shrink-0 bg-base-gray flex flex-col items-center justify-center">
        <img width={150} src={logo} alt="logo" className="mb-6" />

        <div className="self-start pl-11 w-full">
          <p className="text-left text-lg mb-1">Login</p>
          <div className="w-11 h-[2px] bg-offer-blue mb-2"></div>
        </div>
        <div className="w-4/5 border-b-[1px] border-gray-200 mb-8"></div>

        <Form
          name="basic"
          className="w-[90%] sm:w-4/5 gap-[22px]"
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
        >
          <Form.Item<LoginFieldType>
            name="username"
            rules={[
              {
                required: true,
                message: "Unesite korisničko ime!",
              },
            ]}
          >
            <Input
              prefix={<UserOutlined className="text-offer-blue pr-2" />}
              className="h-10 text-[16px] "
              placeholder="korisničko ime"
            />
          </Form.Item>

          <Form.Item<LoginFieldType>
            name="password"
            rules={[
              {
                required: true,
                message: "Unesite lozinku!",
              },
              { min: 6 },
            ]}
          >
            <Input.Password
              prefix={<LockOutlined className="text-offer-blue pr-2" />}
              className="h-10 text-[16px] "
              placeholder="lozinka"
            />
          </Form.Item>

          <Space className="flex justify-between">
            <Form.Item<LoginFieldType>
              name="rememberMe"
              valuePropName="checked"
            >
              <Checkbox>Zapamti me</Checkbox>
            </Form.Item>

            <Form.Item>
              <Link
                className="sm:text-[16px] text-offer-blue"
                to={NavigationPath.RESET_PASSWORD_ROUTE}
              >
                Zaboravljena lozinka
              </Link>
            </Form.Item>
          </Space>

          <Form.Item>
            <Button
              type="primary"
              className="text-white font-bold w-[118px] h-10 text-[16px] bg-offer-blue rounded-none"
              htmlType="submit"
            >
              PRIJAVI SE
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default Login;
